import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LoginService } from '../services/login.service';

@Injectable()
// Import necessary dependencies
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: LoginService) { }

    // Interceptor method to handle HTTP requests and responses
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Intercept and handle HTTP request
        return next.handle(request).pipe(catchError(err => {
            // Handle errors in the HTTP response

            // If the response status is 401 (Unauthorized), perform the following actions
            if (err.status === 401) {
                // Auto logout the user if the API returns a 401 response
                // Note: The following line is commented out, you may need to uncomment it for auto logout functionality
                // this.authenticationService.logout();

                // Reload the page to reflect the logged-out state
                location.reload();
            }

            // Extract error message from the response or use the status text as an error message
            const error = err.error.message || err.statusText;

            // Throw the error as an observable to be caught by the subscriber
            return throwError(error);
        }));
    }
}
